<h2 mat-dialog-title>
  <div class="add-members-dialog-grid dialog-title-grid">
    <div class="left-col dialog-title-left">Changes to your plan</div>
    <div class="right-col dialog-title-right">
      <span>{{ userEmail }}</span>
      <button mat-icon-button aria-label="Close" (click)="close()" class="dialog-title-close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</h2>
<div mat-dialog-content>
  <div class="add-members-dialog-grid">
    <div class="left-col">
      <div class="info-text">
        You’re adding {{ newMembers().length }} new team member{{ newMembers().length > 1 ? 's' : '' }} to your account.<br/>
        You will be charged a prorated ${{ proratedAmount().toFixed(2) }} through the end of the month, transitioning to
        an additional ${{ newMonthlyAmount().toFixed(2) }}/month on your next billing date.
      </div>
      <div class="payment-methods">
        <!-- Stripe Elements payment methods go here -->
        @if (clientSecret() && customerSessionClientSecret()) {
          <ngx-stripe-elements
            [stripe]="stripe"
            [elementsOptions]="stripeElementsOptions()"
            (elements)="onElementsCreated($event)">
            <ngx-stripe-payment
            [options]="paymentElementOptions()">
              >
            </ngx-stripe-payment>
          </ngx-stripe-elements>
        }
      </div>
    </div>
    <div class="right-col">
      <div class="summary-panel">
        <div class="panel-header">
          <h3>Summary of monthly fee</h3>
        </div>
        @if (plan()) {
          <div class="panel-body">
            <div class="line-item odd">
              <label>Subscription (Includes 1 Admin)</label>
              <span>${{ nextCycleSubscriptionAmount().toFixed(2) }}/mo</span>
            </div>
            <div class="line-item even">
              <label>Existing Team Members ({{ seatCount() }} × ${{ plan().pricePerSeat.toFixed(2) }})</label>
              <span>${{ (seatCount() * plan().pricePerSeat).toFixed(2) }}/mo</span>
            </div>
            <div class="line-item odd">
              <label>Additional Team Members ({{ newMembers().length }})</label>
              <span></span>
            </div>
            @for (newMember of newMembers(); track newMember; let i = $index) {
              <div class="line-item {{ i % 2 === 0 ? 'even' : 'odd' }}">
                <div class="member-info">
                  <app-user-avatar
                    [size]="'tiny'"
                  ></app-user-avatar>
                  {{ newMember }}
                </div>
                <span>+${{ plan().pricePerSeat.toFixed(2) }}/mo</span>
              </div>
            }
            <div class="panel-footer">
              <div class="line-item total">
                <label>Total per month</label>
                <span>${{ nextCycleTotalAmount().toFixed(2) }}</span>
              </div>
              @if (successMessage(); as success) {
                <div class="form-success">
                  {{ success }}
                </div>
              }
              @if (errorMessage(); as error) {
                <div class="form-error">
                  {{ error }}
                </div>
              }
              <div class="button-wrap text-center" style="margin-top: 24px;">
                <button (click)="pay()" class="button formAction pay-button"
                        [disabled]="paying() || !clientSecret() || !!successMessage()">
                  @if (paying()) {
                    <span class="button-spinner"></span>
                    <span>Processing...</span>
                  } @else {
                    <span>Confirm Payment</span>
                  }
                </button>
              </div>
              <p class="terms" style="margin-top: 12px;">
                You can cancel your plan at any time. Purchases made by credit card can’t be refunded. By clicking
                “Confirm Payment” you agree to our <a [href]="termsLink" target="_blank">Terms of Service</a>.
              </p>
            </div>
          </div>
        } @else {
          <div class="panel-body">
            <div class="spinner-container">
              <p>Loading plan details...</p>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
